module.exports = __webpack_public_path__ + "img/highSpeedRail-5.012bbeed.jpg";